import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation DeleteAnnouncement($id: String!) {
    deleteAnnouncement(id: $id)
  }
`);

export const mutationFn = async (id: VariablesOf<typeof QUERY>['id']) => {
  const response = await gqlClient.request(QUERY, { id });

  if ('deleteAnnouncement' in response) {
    return response.deleteAnnouncement;
  }
};
